// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.261a9e719',
  revision: '261a9e719',
  branch: 'develop',
  date: 'Fri, 18 Sep 2026 11:11:43 GMT'
};